import React from 'react';

import MomentUtils from '@date-io/moment';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { CompatRouter } from 'react-router-dom-v5-compat';

import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';

import { StoreManager } from './reducers/store-manager';

import { AppRouting } from './app-routing';
import { AuthenticationProvider } from './authentication/authentication-provider';
import { GlobalDialogs } from './dialogs/global-dialogs';
import { FeatureFlagged, FeatureGatedVariant } from './feature-gates/feature-flagged';
import { FeatureGates } from './feature-gates/feature-gates';
import { LegacyAppRouting } from './legacy-app-routing';
import theme from './theme';

import { BrowserHistorySpy } from './widgets/browser-history-spy';
import { DefaultDisplaySettingsMigrator } from './widgets/default-display-settings-migrator';
import { ErrorBoundary } from './widgets/error-boundary';
import { Nav } from './widgets/nav';
import { SnackbarNotifications } from './widgets/snackbar-notifications';

const store = StoreManager.getStore();

const App = () => (
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <Router>
        <CompatRouter>
          <AuthenticationProvider>
            <BrowserHistorySpy />
            <DefaultDisplaySettingsMigrator />
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <ErrorBoundary>
                <div>
                  <CssBaseline />
                  <GlobalDialogs />
                  <Nav />
                  <FeatureFlagged
                    variant={FeatureGatedVariant.HIDE_ON_FLAG}
                    flagName={FeatureGates.INTEGRATED_MESSAGING}
                  >
                    <LegacyAppRouting />
                  </FeatureFlagged>
                  <FeatureFlagged
                    variant={FeatureGatedVariant.SHOW_ON_FLAG}
                    flagName={FeatureGates.INTEGRATED_MESSAGING}
                  >
                    <AppRouting />
                  </FeatureFlagged>
                  <SnackbarNotifications />
                </div>
              </ErrorBoundary>
            </MuiPickersUtilsProvider>
          </AuthenticationProvider>
        </CompatRouter>
      </Router>
    </ThemeProvider>
  </Provider>
);

export default App;
